export default Object.freeze({
  MALL: '쇼핑몰',
  ALL: '전체',
  BTN_SEARCH: '조회',
  BTN_CANCEL: '초기화',
  RESERVATION_LABEL: '예약주문 함께보기',
  MEMBER_GROUP: '회원그룹',
  SEARCH_WORD: '검색어',
  SEARCH_WORD_PLACEHOLDER: '검색어 입력',
  SEARCH_DATE_TYPE: '기간',
  PAY_TYPE: '결제수단',
  CLAIM_STATUS_DETAIL_LABEL: '클레임상태',
  SHIPPING_AREA_TYPE: '배송구분',
  INCLUDE_HOLDER_DELIVERY: '배송보류 함께보기',
  TASK_MESSAGE_SEARCH_TYPE: '업무메시지',

  CANCEL_DELAY: '취소지연',
  EXCHANGE_DELAY: '교환지연',
  RETURN_DELAY: '반품지연',

  CANCEL_APPLY_YMDT: '취소신청일시',
  EXCHANGE_APPLY_YMDT: '교환신청일시',
  RETURN_APPLY_YMDT: '반품신청일시',
  REFUND_APPLY_YMDT: '환불신청일시',

  CANCEL_COMPLETE_YMDT: '취소완료일시',
  EXCHANGE_COMPLETE_YMDT: '교환완료일시',
  RETURN_COMPLETE_YMDT: '반품완료일시',
  REFUND_COMPLETE_YMDT: '환불완료일시',

  CHECK_CLAIM_STATUS_VALIDATION_MESSAGE: '조회하려는 클레임상태를 체크해주세요',
  CHECK_PLATFORM_TYPE_VALIDATION_MESSAGE: '조회하려는 플랫폼구분을 체크해주세요',
  CHECK_PAY_TYPE_VALIDATION_MESSAGE: '조회하려는 결제수단을 체크해주세요.'
});
